<script lang="ts" setup>
import type { IProps } from './RecentReports.types'
import RecentReport from './RecentReport.vue'
import { BsButton } from '@afo/bsf-core'
import { useRouteLink } from '@/composables/useRouteLink'
import { ROUTE_PATHS } from '@/utils/route'

defineProps<IProps>()
const { routeLink } = useRouteLink()

</script>

<template>
  <article class="recent-reports">
    <div class="recent-reports__container">
      <h2 class="recent-reports__heading">
        {{ $t('investor.mainPage.reports.title') }}
      </h2>

      <div class="recent-reports__content">
        <RecentReport
          v-for="report in reports"
          :key="report.id"
          v-bind="report"
        />
      </div>

      <NuxtLink
        class="recent-reports__link"
        :to="routeLink(ROUTE_PATHS.FOR_INVESTORS_REPORTS_INDEX)"
      >
        <BsButton>
          {{ $t('investor.mainPage.reports.seeMore') }}
        </BsButton>
      </NuxtLink>
    </div>
  </article>
</template>

<style lang="scss" scoped>
.recent-reports {
  @include section-investor();
  display: grid;
  justify-content: center;
  align-items: center;
  background-color: $gray-100;

  &__container {
    @include section-investor__container();
  }

  &__heading {
    @include h7;
    margin-bottom: 4.8rem;
    color: $text-400;
    text-align: center;
  }

  &__content {
    display: grid;
    align-items: stretch;
    grid-auto-flow: row;
    gap: 1.6rem;
  }

  &__link {
    display: block;
    margin: 3.2rem auto 0;
    text-align: center;
  }

  @include atXS {
    &__heading {
      @include h5;
      margin-bottom: 6.4rem;
    }
  }

  @include atM {
    margin: 0 auto;

    &__content {
      grid-template-columns: repeat(3, 1fr);
      grid-auto-flow: column;
      gap: 2.4rem;
    }
  }
}
</style>
